export const systemPrincipal = { value: '-', type: 'system' };
class AbstractAuthorizationTokenType {
    raw;
    constructor(raw) {
        this.raw = raw;
    }
    value = () => `${this.prefix} ${this.raw}`;
}
export const bearer = (raw) => new Bearer(raw);
export const parseBearer = (raw) => new Bearer(raw.substring('Bearer '.length));
class Bearer extends AbstractAuthorizationTokenType {
    constructor(raw) {
        super(raw);
    }
    prefix = 'Bearer';
}
export const apiKeyToken = (raw) => new ApiKey(raw.substring('ApiKey '.length));
class ApiKey extends AbstractAuthorizationTokenType {
    constructor(raw) {
        super(raw);
    }
    prefix = 'ApiKey';
}
export const samePrincipal = (one, other) => one.value === other.value && one.type === other.type;
export const anonymous = (raw) => new Anonymous(raw);
export const parseAnonymous = (raw) => new Anonymous(raw.substring('Anonymous '.length));
class Anonymous extends AbstractAuthorizationTokenType {
    constructor(raw) {
        super(raw);
    }
    prefix = 'Anonymous';
}
//# sourceMappingURL=index.js.map